import { Wrapper } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';

import DroneCard from 'pages/MaintenancePage/components/DroneCard';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneCardGrid: FunctionComponent<Props> = ({
    className = '',
    drones,
    isAdmin,
    onOpenDrone,
    onSetAirworthy,
    onSetLifecycle,
    phase,
    serviceIntervals,
    testId = TEST_ID
}) => {
    const { NO_DRONES_MATCH } = useTranslation();

    if (drones.length === 0) {
        return <EmptyState className={className} text={NO_DRONES_MATCH} />;
    }

    return (
        <Wrapper className={`${styles.cardGrid} ${className}`} testId={testId}>
            {drones.map(drone => (
                <DroneCard
                    drone={drone}
                    isAdmin={isAdmin}
                    key={drone.id}
                    onOpen={onOpenDrone}
                    onSetAirworthy={onSetAirworthy}
                    onSetLifecycle={onSetLifecycle}
                    phase={phase}
                    serviceIntervals={serviceIntervals}
                />
            ))}
        </Wrapper>
    );
};

export default DroneCardGrid;
